import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Replace with Sentry.captureException(error, { extra: info }) when Sentry is set up
    console.error("[Subtrack] Uncaught error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", minHeight: "100vh", padding: "2rem",
          fontFamily: "'DM Sans', sans-serif", background: "#f9f8f6", textAlign: "center"
        }}>
          <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>😕</div>
          <div style={{ fontSize: "18px", fontWeight: 500, color: "#1a1a1a", marginBottom: "0.5rem" }}>
            Something went wrong
          </div>
          <div style={{ fontSize: "14px", color: "#888", marginBottom: "1.5rem", maxWidth: 360, lineHeight: 1.6 }}>
            The app hit an unexpected error. Refreshing usually fixes it — if it keeps happening, email{" "}
            <a href="mailto:michael@scalewithme.co" style={{ color: "#2d6a4f" }}>michael@scalewithme.co</a>.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              fontFamily: "inherit", fontSize: "14px", fontWeight: 500,
              color: "#fff", background: "#2d6a4f", border: "none",
              borderRadius: "10px", padding: "10px 24px", cursor: "pointer"
            }}
          >
            Reload app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
